import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { SOLD_SERVICES_CONTENT_MODE } from '../typings'
import type {
  NewOpp,
  EditOpp,
  ConvertLead,
  DuplicateOpp,
  CloneOpp,
} from './typings'
import { ServicesAddedEdit } from './ServicesAddedEdit'
import { ServicesAddedNew } from './ServicesAddedNew'

type Props = {
  entityType: ENTITY_TYPES
} & (NewOpp | EditOpp | ConvertLead | DuplicateOpp | CloneOpp)

export function ServicesAdded(props: Props) {
  switch (props.type) {
    case SOLD_SERVICES_CONTENT_MODE.EditOpp:
      return <ServicesAddedEdit {...props} />

    case SOLD_SERVICES_CONTENT_MODE.NewOpp:
    case SOLD_SERVICES_CONTENT_MODE.ConvertLead:
    case SOLD_SERVICES_CONTENT_MODE.CloneOpp:
    case SOLD_SERVICES_CONTENT_MODE.DuplicateOpp:
      return <ServicesAddedNew {...props} />
  }
}
